<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon>mdi-eye-outline</v-icon>
            </v-btn>
        </template>
        <v-card max-width="500" class="mx-auto">
            <v-card-title class="my-5">
                <h4 class="title blue-grey--text text--accent-4">새 방장으로 선택합니까?</h4>
            </v-card-title>
            <v-card-text>
                <v-list shaped>
                    <v-list-item-group v-model="item" color="blue-grey">
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-img :src="member.avatar"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="member.name"></v-list-item-title>
                                <v-list-item-subtitle v-text="member.alias"></v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-content>
                                <v-list-item-title v-text="member.total"></v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ member.level }}부                                
                                    <span v-for="n in member.level" :key="n">
                                        <v-icon small color="orange">mdi-star</v-icon>
                                    </span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-btn text>{{member.wins}}승/{{member.loses}}패</v-btn>
                            </v-list-item-icon>                    
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" dark class="mb-3" color="blue-grey" @click="selectNewLeader">Yes!</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
  
</template>

<script>
import db from '@/fb'

export default {
    name: 'SelectNewLeader',
    props: [ 'user', 'member', 'groupId', 'group'],
    data: () => ({
        dialog: false,
        loading: false,
        item: 0
    }),
    methods: {
        selectNewLeader(){
            this.loading = true;
            let creator = {
                name: this.member.name,
                alias: this.member.alias,
            }
            let imgURL = this.member.avatar

            // update the group
            db.collection('groups').doc(this.groupId).update({
                creator: creator,
                imgURL: imgURL
            }).then(() => {
                this.loading = false;
                this.$router.push({ name: 'MyPage' })
            })                          
        }
    }
};
</script>